/* Zydonia Redesign: Stammdaten (Texte, Farben, Momente, Sets).
   Varianten-IDs, Einzelpreise und Verfügbarkeit kommen live aus Shopify (window.ZY_CFG, gesetzt in snippets/zyx-head.liquid).
   Staffelpreise müssen zu den automatischen Rabatten in Shopify passen. */
(function () {
  const CFG = window.ZY_CFG || { assets: '', products: {} };
  // Bilder liegen als Theme-Assets vor: zy-<name>-<breite>.webp, Tag-Version als zy-day-<name>-<breite>.webp
  const dayImgs = ['hero-desktop', 'hero-mobile', 'hero-cine', 'mood-morgen', 'mood-fokus', 'friends-dinner', 'ingredients', 'lineup',
    'set-abend2', 'set-fokus2', 'detail-macro', 'howto-hand', 'refill-ritual', 'gift-box',
    'pack-refill', 'pack-candle', 'pack-oil', 'pack-parfum',
    'pack-light-jasmin', 'pack-ginger-flower', 'pack-lipa-spa', 'pack-lavender-dream', 'pack-mystic-ouds',
    'pack-sunshine-vibes', 'pack-rose-garden', 'pack-bergamot-breeze', 'pack-royal-saffron',
    'pf-invisible-desire', 'pf-nocturne', 'pf-aqua-celeste', 'pfbox-invisible-desire', 'pfbox-nocturne', 'pfbox-aqua-celeste',
    'pfnotes-invisible-desire', 'pfnotes-nocturne', 'pfnotes-aqua-celeste', 'pf-trio',
    'pflife-invisible-desire', 'pflife-nocturne', 'pflife-aqua-celeste-w', 'pflife-aqua-celeste-m'];
  const DAY = new Set(dayImgs);
  // Vorschaubilder Warenkorb/„Passt dazu“ (Refill rfc-, Öle oec-) haben ebenfalls Tag-Versionen
  ['light-jasmin', 'ginger-flower', 'lipa-spa', 'lavender-dream', 'mystic-ouds', 'sunshine-vibes', 'rose-garden', 'bergamot-breeze', 'royal-saffron']
    .forEach(s => DAY.add('rfc-' + s));
  ['weihrauch', 'niaouli', 'zedernholz', 'lavendel', 'eukalytpus', 'orange', 'ylang-ylang', 'rosmarin', 'rose', 'jasmin', 'vanille', 'zitronengras', 'bergamotte', 'patchouli', 'grapefruit']
    .forEach(s => DAY.add('oec-' + s));
  // Im Craft-Theme heißt das Merkmal data-zy-theme (kollidiert nicht mit Craft)
  const isLight = () => document.documentElement.dataset.zyTheme === 'light';
  // Refill-Sorten mit eigenen Tag-/Nacht-Bildern (freigeschaltet); weitere Dateien liegen schon bereit, siehe assets/zyx-variants.js
  const RF8 = ['light-jasmin', 'ginger-flower', 'lipa-spa', 'lavender-dream', 'mystic-ouds'];
  const asset = (file, light) => CFG.assets + 'zy-' + (light ? 'day-' : '') + file;
  const img = (name, w) => asset(`${name}-${w}.webp`, isLight() && DAY.has(name));

  const scents = [
    {
      id: 'light-jasmin', name: 'Light Jasmin', moment: 'tag',
      mood: 'Fokus ohne Stress', short: 'Klare Gedanken, innere Ruhe und Fokus',
      line: 'Macht den Kopf klar und lässt Stress abfallen. Konzentration fühlt sich leicht an statt anstrengend.',
      notes: ['Zitrone', 'Jasmin', 'Grüntee'],
      science: 'Zitrone liefert limonenreiche Frische, die in Studien mit mehr Wachheit verbunden wird. Jasmin setzt den Gegenpol, damit Wachheit nicht in Druck kippt. Grüntee ergänzt die Balance: Beim Riechen aromatischer Grüntees wurden stressmindernde Effekte beobachtet.',
      label: '#ebe5d2', glow: '#c6d39c', life: ['mood-fokus2'], refill: true, giftable: true
    },
    {
      id: 'ginger-flower', name: 'Ginger Flower', moment: 'morgen',
      mood: 'Gute Laune und Antrieb', short: 'Energie, Motivation und Antrieb',
      line: 'Hellt die Stimmung auf, gerade an Tagen, die sich schwer und grau anfühlen.',
      notes: ['Ingwer', 'Zitrone', 'Minze'],
      science: 'Ingwer bildet die warme, aktivierende Basis. Zitrone verstärkt den Schwung mit hellen Zitrusnoten, Minze setzt mit Menthol einen klaren, wachen Akzent.',
      label: '#eed79a', glow: '#e2b451', life: ['mood-morgen'], refill: true, giftable: true
    },
    {
      id: 'lipa-spa', name: 'Lipa Spa', moment: 'morgen',
      mood: 'Wach und vital', short: 'Frische, Vitalität und neue Kraft',
      line: 'Macht dich wacher und klarer, ohne dass es sich nervös anfühlt. Wie ein Spa-Morgen zu Hause.',
      notes: ['Zitrone', 'Mandarine', 'Patchouli'],
      science: 'Zitrone und Mandarine sind reich an Limonen, das im Duft als Frische und Klarheit ankommt. In Untersuchungen zur Inhalation von Zitronenöl berichten Probanden von mehr Wachheit. Patchouli gibt der Mischung Tiefe, damit Energie nicht in Hektik kippt.',
      label: '#c3dbe6', glow: '#6fb3c9', life: ['mood-morgen', 'refill-ritual'], refill: true, giftable: true
    },
    {
      id: 'lavender-dream', name: 'Lavender Dream', moment: 'abend',
      mood: 'Schlaf und Ruhe', short: 'Ruhe, Entspannung und Erholung',
      line: 'Bringt dich am Abend runter, damit Einschlafen leichter wird und der Morgen sich nach Erholung anfühlt.',
      notes: ['Lavendel', 'Eukalyptus', 'Sandelholz'],
      science: 'Lavendel ist der beruhigende Kern: Seine Duftbestandteile Linalool und Linalylacetat werden mit Entspannung in Verbindung gebracht. Eukalyptus bringt mit 1,8-Cineol Klarheit, wenn abends noch Gedanken kreisen. Sandelholz rundet die Mischung warm ab.',
      label: '#d9d0e6', glow: '#9580c4', life: ['mood-abend'], refill: true, giftable: true
    },
    {
      id: 'mystic-ouds', name: 'Mystic Ouds', moment: 'abend',
      mood: 'Erdung und Geborgenheit', short: 'Wärme, Geborgenheit und Erdung',
      line: 'Wärmt, erdet und nimmt Druck raus. Kraft, die aus Ruhe entsteht.',
      notes: ['Rosenöl', 'Zedernholz', 'Patchouli', 'Gurjunbalsam'],
      science: 'Rosenöl setzt den emotionalen Schwerpunkt, Zedernholz gibt Struktur und Erdung. Patchouli vertieft die Wärme, Gurjunbalsam schließt harzig ab und trägt den Duft lange im Raum.',
      label: '#b9643f', glow: '#cf6a36', life: ['friends-dinner'], refill: true, giftable: true
    },
    {
      id: 'sunshine-vibes', name: 'Sunshine Vibes', moment: 'morgen',
      mood: 'Leichtigkeit und gute Laune', short: 'Leichtigkeit, Freude und gute Laune',
      line: 'Fühlt sich an wie ein heller Sommertag bei offenem Fenster: zitrisch, leicht und sonnig.',
      notes: ['Zitrusfrüchte', 'helle Blüten'],
      science: 'Zitrusnoten mit Terpenen wie Limonen sorgen für den hellen, frischen Charakter. Florale Nuancen nehmen der Frische die Schärfe und machen den Duft weich und harmonisch.',
      label: '#f2cb3c', glow: '#f0b528', life: ['mood-morgen'], refill: false, giftable: false, soldOut: true
    },
    {
      id: 'rose-garden', name: 'Rose Garden', moment: 'tag',
      mood: 'Harmonie und Sinnlichkeit', short: 'Harmonie, Sinnlichkeit und Eleganz',
      line: 'Holt einen ganzen Rosengarten in den Raum. Blühend, sinnlich und nie schwer.',
      notes: ['Rosenöl', 'Geranie', 'grüne Blätter'],
      science: 'Rosenöl ist das Herz des Dufts, getragen von Citronellol und Geraniol. Geranie macht die Blüte lebendiger und leicht grün, grüne Blattnoten setzen den Garten drumherum.',
      label: '#eac6c9', glow: '#d98e9b', life: ['howto-hand'], refill: false, giftable: false
    },
    {
      id: 'bergamot-breeze', name: 'Bergamot Breeze', moment: 'tag',
      mood: 'Klarheit und Gelassenheit', short: 'Frische, Klarheit und Leichtigkeit',
      line: 'Oben eine frische Bergamotte-Brise, unten erdige Tiefe. Klar im Kopf, aber entspannt.',
      notes: ['Bergamotte', 'Patchouli', 'Moos'],
      science: 'Ein Chypre-Duft: oben Bergamotte mit Linalylacetat, Linalool und Limonen, unten Patchouli und eine moosige Basis. Der Kontrast macht ihn hell und trotzdem geerdet.',
      label: '#bcd35e', glow: '#9cc23a', life: ['set-fokus2'], refill: false, giftable: false
    },
    {
      id: 'royal-saffron', name: 'Royal Saffron', moment: 'abend',
      mood: 'Wärme und Luxus', short: 'Wärme, Sinnlichkeit und Ruhe',
      line: 'Der luxuriöseste Duft der Kollektion. Riecht wie die Lobby eines Grandhotels: warm, kostbar, ruhig.',
      notes: ['Safran', 'Sandelholz', 'Amber'],
      science: 'Safran gilt als teuerstes Gewürz der Welt, für ein Kilo braucht es rund 150.000 Blüten. Sandelholz stabilisiert die Komposition, Amber legt einen warmen Schleier über den Raum.',
      label: '#a8292b', glow: '#c23b2c', life: ['hero-cine'], refill: false, giftable: false
    }
  ];

  const moments = [
    { id: 'morgen', label: 'Morgens', title: 'Wach werden, ohne Hektik.', text: 'Zitrus, Ingwer und Minze bringen Frische in den Raum und machen den Kopf klar. Für Küche, Bad und den ersten Kaffee.', img: 'mood-morgen', lead: 'lipa-spa' },
    { id: 'tag', label: 'Tagsüber', title: 'Klar bleiben, auch wenn es voll wird.', text: 'Jasmin, Bergamotte und Grüntee können dir helfen, bei der Sache zu bleiben. Für Schreibtisch, Homeoffice und Wohnzimmer.', img: 'mood-fokus', lead: 'light-jasmin' },
    { id: 'abend', label: 'Abends', title: 'Ankommen und runterfahren.', text: 'Lavendel, Sandelholz und Safran machen den Raum warm und ruhig. Für Schlafzimmer, Sofa und lange Abende.', img: 'mood-abend', lead: 'lavender-dream' }
  ];

  // Preisstaffel pro Set (Anzahl Düfte = Anzahl Flakons à 150 ml)
  // 1 bis 3 = Live-Staffel (Kaching). 4 = VORSCHLAG.
  const single = 44.95;
  const tiers = [
    { qty: 1, price: 44.95 },
    { qty: 2, price: 69.95 },
    { qty: 3, price: 79.95, badge: 'Beliebteste Wahl' },
    { qty: 4, price: 94.95, badge: 'Bester Preis', proposal: true }
  ];

  // Warenkorb-Schwellen. 35 € = Live. 79 € und 149 € = VORSCHLAG (Geschenk-Produkte existieren im Shop mit 0 €).
  const thresholds = [
    { amount: 35, key: 'shipping', label: 'Versand gratis', icon: 'ph-truck' },
    { amount: 79, key: 'oil', label: 'Ätherisches Öl gratis', icon: 'ph-drop', proposal: true },
    { amount: 149, key: 'diffuser', label: 'Raumduft gratis', icon: 'ph-gift', proposal: true }
  ];

  const oils = [
    { v: 'Weihrauch', price: 5.95 }, { v: 'Niaouli', price: 4.95 }, { v: 'Zedernholz', price: 5.95 },
    { v: 'Lavendel', price: 6.95 }, { v: 'Eukalyptus', price: 3.95 }, { v: 'Orange', price: 5.95 }
  ];

  const products = {
    refill: { id: 'refill', name: 'Refill 500 ml', sub: 'Reicht für drei Füllungen', price: 74.95, bundlePrice: 59.95, img: 'pack-refill', ml: 500,
      variants: ['Lipa Spa', 'Mystic Ouds', 'Ginger Flower', 'Lavender Dream', 'Light Jasmin'] },
    candle: { id: 'candle', name: 'Duftkerze 530 ml', sub: 'Bio-Sojawachs, handgegossen', price: 69.95, img: 'pack-candle',
      variants: ['Lule', 'Lume', 'Lavenna', 'Lorena'] },
    oil: { id: 'oil', name: 'Ätherisches Öl 10 ml', sub: '100 % naturrein', price: 5.95, img: 'pack-oil',
      variants: oils.map(o => o.v), prices: Object.fromEntries(oils.map(o => [o.v, o.price])) },
    parfum: { id: 'parfum', name: 'Extrait de Parfum', sub: 'Mindestens 30 % Duftöl', price: 74.95, compare: 89.95, img: 'pack-parfum',
      variants: ['Nocturne', 'Essence Absolue', "Elixir D'Or", 'Rosalia', 'Eternelle', 'Invisible Desire'] }
  };

  // VORSCHLAG: Geschenkverpackung als Add-on
  const giftwrap = { price: 4.95, label: 'Geschenkverpackung mit Grußkarte' };

  const sets = [
    { id: 'abendritual', name: 'Abendritual', scents: ['lavender-dream', 'mystic-ouds', 'royal-saffron'], img: 'set-abend2',
      text: 'Stress loslassen, zur Ruhe finden, den Tag ausklingen lassen.' },
    { id: 'klarer-kopf', name: 'Klarer Kopf', scents: ['light-jasmin', 'bergamot-breeze', 'lipa-spa'], img: 'set-fokus2',
      text: 'Frisch, wach und fokussiert. Für Schreibtisch, Wohnbereich und Bad.' }
  ];

  // Echte Kundenstimmen von der Live-Produktseite (gekürzt, Wortlaut unverändert)
  const reviews = [
    { name: 'Monika U.', date: '5. Mai 2026', text: 'Steht im Schlafzimmer auf einer Kommode. Man riecht den tollen Duft sogar am Gang beim Vorbei gehen.' },
    { name: 'Bozena C.', date: '20. Sept. 2026', text: 'Ich habe mir mehre Düfte bestellt und alle sind sehr schön. Die Düfte sind nicht zu stark und passen in jede Wohnung.', verified: true },
    { name: 'Tatjana P.', date: '8. Sept. 2026', text: 'Ganz toller, dezenter Duft nach Sommer gar nicht aufdringlich wie man das sonst von Raum Düften kennt.' },
    { name: 'Merle R.', date: '21. Mai 2026', text: 'Nicht zu aufdringlich. Man freut sich schon darauf nach hause zu kommen.' },
    { name: 'Miriam H.', date: '9. Sept. 2026', text: 'Riecht sehr angenehm und gut dosierbar durch ausreichend Stäbchen. Lavendel passend zum Schlafen.' },
    { name: 'Marcela G.', date: '29. Apr. 2026', text: 'Riecht sehr angenehm in ganzem großem Esswohnbereich. Top!!!' }
  ];
  // Loox, alle Produkte zusammen (Stand 27.09.2026: Raumduft 875, Kerzen 65, Refill 54, Öle 35, B-Ware 4)
  const rating = { value: 4.8, count: 1033 };

  const faq = [
    { q: 'Wie lange hält ein Flakon?', a: 'Bis zu 6 Wochen, je nach Raumgröße, Temperatur, Luftzirkulation und Anzahl der Stäbchen. Wir empfehlen, mit 2 bis 3 Stäbchen zu beginnen.' },
    { q: 'Wie verwende ich die Duftstäbchen richtig?', a: 'Stell alle Stäbchen in den Flakon und dreh sie nach ein bis zwei Tagen um. Das wiederholst du regelmäßig, dann verteilt sich der Duft gleichmäßig. Bist du länger weg, verschließ den Flakon mit dem Stopfen.' },
    { q: 'Sind die Düfte natürlich?', a: 'Wir verwenden überwiegend natürliche Duftöle, kombiniert mit fein abgestimmten Duftträgern. So bleibt die Duftabgabe gleichmäßig und lange stabil, ohne scharfe oder künstliche Noten.' },
    { q: 'Kann ich meinen Duft nachbestellen?', a: 'Ja, alle Zydonia-Düfte sind dauerhaft erhältlich. Mit dem Refill (500 ml) füllst du deinen Flakon einfach wieder auf.' },
    { q: 'Wirkt ein Duft bei jedem gleich?', a: 'Nein. Wie ein Duft wirkt, prägen auch Erinnerungen und Vorlieben. Deshalb sagen wir, dass Aromen eine Stimmung unterstützen können. Das ist kein medizinisches Wirkversprechen.' },
    { q: 'Wie schnell kommt meine Bestellung?', a: 'Wir versenden mit DHL, bei dir ist die Bestellung in 2 bis 5 Werktagen. Ab 35 € ist der Versand kostenlos. Gefällt dir dein Duft nicht, schick ihn innerhalb von 14 Tagen zurück und du bekommst den vollen Kaufpreis erstattet.' }
  ];

  /* ---------- Neuroparfums (Extrait de Parfum, 50 ml) ----------
     Preise und Staffel = Live-Shop (Kaching). Wirkungsaussagen bewusst direkt (User-Entscheidung, Risiko siehe README). */
  const perfumes = [
    {
      id: 'invisible-desire', name: 'Invisible Desire', for: 'Für sie', short: 'Anziehung', effect: 'Anziehung und Verlangen',
      claim: 'Macht dich anziehend.',
      headline: 'Anziehung, die man nicht sieht. Aber spürt.',
      line: 'Invisible Desire steigert deine Anziehungskraft. Der Pheromon-Komplex sendet Signale, die Verlangen wecken, bevor du ein Wort sagst.',
      family: 'Floral Gourmand', top: ['Blutorange'], heart: ['Honig', 'Gardenie'], base: ['Patchouli', 'Vetiver'],
      label: '#5b1f33', glow: '#b8364f', lifes: ['pflife-invisible-desire']
    },
    {
      id: 'nocturne', name: 'Nocturne', for: 'Für ihn', short: 'Präsenz', effect: 'Männlichkeit und Präsenz',
      claim: 'Macht dich präsent.',
      headline: 'Männlich. Dominant. Präsent.',
      line: 'Nocturne verstärkt deine Präsenz. Ausgewählte Aromen senden Signale an das Gehirn, die Selbstsicherheit, Präsenz und innere Ruhe stärken. Und genau das strahlst du nach außen aus.',
      family: 'Würzig Aromatisch', top: ['Lavendel', 'Bergamotte', 'Zitrone'], heart: ['Honig', 'Zimt', 'Jasmin Sambac'], base: ['Tabakblatt', 'Tonkabohne', 'Vanille'],
      label: '#1a1612', glow: '#c98a3b', lifes: ['pflife-nocturne']
    },
    {
      id: 'aqua-celeste', name: 'Aqua Celeste', for: 'Für alle', short: 'Selbstbewusstsein', effect: 'Selbstbewusstsein',
      claim: 'Macht dich selbstbewusst.',
      headline: 'Selbstbewusstsein zum Aufsprühen.',
      line: 'Aqua Celeste stärkt dein Selbstbewusstsein. Ausgewählte ätherische Öle fördern eine klare, souveräne Ausstrahlung. Im Meeting, beim Date, überall.',
      family: 'Aquatisch Zitrisch', top: ['Zitrone', 'Bergamotte', 'Orange'], heart: ['Neroli', 'Ingwer', 'Zimt'], base: ['Schwarztee', 'Ambroxan', 'Guajakholz'],
      label: '#bcd8e6', glow: '#5ab3d4', lifes: ['pflife-aqua-celeste-w', 'pflife-aqua-celeste-m']
    }
  ];
  const perfume = { single: 74.95, uvp: 89.95, ml: 50,
    tiers: [
      { qty: 1, pay: 1, price: 74.95, label: '1 Extrait de Parfum' },
      { qty: 3, pay: 2, price: 149.90, label: '2 + 1 gratis' },
      { qty: 5, pay: 3, price: 224.85, label: '3 + 2 gratis', badge: 'Beliebteste Wahl' }
    ],
    trio: { id: 'neuro-trio', name: 'Neuroparfum-Trio', scents: ['invisible-desire', 'nocturne', 'aqua-celeste'] }
  };

  /* ---------- Abgleich mit Shopify ---------- */
  const P = CFG.products || {};
  const room = P.room || { variants: {} };
  // Raumduft: Variante je Duft über den Namen, Verfügbarkeit aus Shopify
  scents.forEach(s => {
    const v = room.variants[s.name];
    s.variant = v ? v.id : null;
    s.soldOut = !v || !v.available;
    s.url = (room.url || '/') + (v ? '?variant=' + v.id : '');
  });
  const firstRoom = Object.values(room.variants)[0];
  const liveSingle = firstRoom ? firstRoom.price : single;
  tiers[0].price = liveSingle;
  // 4er-Staffel gibt es im Shop noch nicht: nur zeigen, wenn im Theme-Editor freigeschaltet
  const liveTiers = tiers.filter(t => !t.proposal || CFG.tier4);
  perfumes.forEach(p => {
    const v = (P.perfumes || {})[p.id];
    p.variant = v ? v.id : null;
    p.available = !!(v && v.available);
    p.url = v ? v.url : '/';
  });
  if (P.perfumes && P.perfumes['invisible-desire']) {
    perfume.single = P.perfumes['invisible-desire'].price;
    if (P.perfumes['invisible-desire'].compare) perfume.uvp = P.perfumes['invisible-desire'].compare;
  }
  // Refill, Kerze, Öl: Varianten aus Shopify
  ['refill', 'candle', 'oil'].forEach(k => {
    const src = P[k];
    if (!src) return;
    const p = products[k];
    p.url = src.url;
    p.vmap = src.variants;
    // Refill-Vorschaubilder für Warenkorb und „Passt dazu“: Flasche auf dem Stein, Tag/Nacht (zy-[day-]rfc-<duft>-600.webp, alle 9 Düfte vorhanden).
    // Auf die Shopify-Variantenbilder zurück, indem REFILL_OWN_THUMBS auf false gesetzt wird.
    const REFILL_OWN_THUMBS = true;
    const RFC = ['light-jasmin', 'ginger-flower', 'lipa-spa', 'lavender-dream', 'mystic-ouds', 'sunshine-vibes', 'rose-garden', 'bergamot-breeze', 'royal-saffron'];
    if (k === 'refill' && REFILL_OWN_THUMBS) Object.entries(src.variants).forEach(([n, v]) => {
      const sl = n.toLowerCase().replace(/\s+/g, '-');
      if (!RFC.includes(sl)) return;
      Object.defineProperty(v, 'img', { configurable: true, enumerable: true, get: () => asset(`rfc-${sl}-600.webp`, isLight()) });
    });
    p.variants = Object.keys(src.variants).filter(n => src.variants[n].available);
    const first = src.variants[p.variants[0]];
    if (first && k !== 'oil') p.price = first.price;
    if (k === 'oil') p.prices = Object.fromEntries(Object.entries(src.variants).map(([n, v]) => [n, v.price]));
  });
  const variantOf = (k, name) => { const p = products[k]; const v = p && p.vmap && (p.vmap[name] || p.vmap[p.variants[0]]); return v ? v.id : null; };
  // Geschenk-Schwellen kommen aus dem Geschenk-Schutz (snippets/zyd-gift-guard.liquid, window.ZYD_GIFTS)
  const GG = window.ZYD_GIFTS;
  if (GG) CFG.thresholds = Object.assign({}, CFG.thresholds, { oil: GG.oil.variants.length ? GG.oil.min : 0, diffuser: GG.room.variants.length ? GG.room.min : 0 });
  thresholds.splice(0, thresholds.length, ...thresholds.filter(t => (CFG.thresholds || {})[t.key] > 0).map(t => Object.assign(t, { amount: CFG.thresholds[t.key] })));

  window.ZY = { img, asset, dayImgs: DAY, isLight, scents, moments, single: liveSingle, ml: 150, tiers: liveTiers, thresholds, products, giftwrap, sets, reviews, rating, faq,
    perfumes, perfume, variantOf, routes: CFG.routes || {},
    pf: id => perfumes.find(p => p.id === id),
    ptier: q => perfume.tiers.find(t => t.qty === q),
    scent: id => scents.find(s => s.id === id),
    scentByName: n => scents.find(s => s.name === n),
    tier: q => tiers.find(t => t.qty === q),
    // kaufmännisch runden (15,825 → 15,83), dann deutsches Format
    eur: v => (Math.round((v + Number.EPSILON) * 100) / 100).toFixed(2).replace('.', ',') + ' €'
  };
})();
